import { EVENT_VOLUME_CHANGE } from '~~/constants/googleTagManager';
import type { TriggerQuantityChangeParameters } from '~~/types/integrations/tagManager/TagManagerIntegration';

export const buildQuantityChangeTags = ({
  actionType,
  selectedQuantity,
  pageCategory,
  sku,
}: TriggerQuantityChangeParameters) => ({
  event: EVENT_VOLUME_CHANGE,
  data: {
    action_type: actionType,
    selected_quantity: selectedQuantity,
    page_category: pageCategory,
    sku,
  },
});
